import { FC, useEffect, useRef, useState } from 'react';
import ArrowDown from '../../assets/arrow_down.png';
import './languageToggle.css';
import { Language, LanguageToggleProps } from './languageToggle.type';
import ActiveCheck from '../../assets/active_check.png';
import FlagIcon from '../flagIcon/flagIcon';
import { languages } from '../../utils/constant';
import { getIdAttributes } from '../../utils/helper';

export const LanguageToggle: FC<LanguageToggleProps> = (props) => {
  const [openLanguageModal, setOpenLanguageModal] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const idPrefix = 'language-toggle';
  const handleSelect = (value: string) => {
    props.setSelected(value);
    setOpenLanguageModal(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setOpenLanguageModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div
      className="language-toggle-container"
      ref={wrapperRef}
      data-testid={idPrefix}
    >
      <button
        onClick={() => setOpenLanguageModal(!openLanguageModal)}
        className="language-toggle-button"
        {...getIdAttributes(idPrefix, 'language-toggle-button')}
      >
        <span className="mr-2">
          <FlagIcon
            svg={
              languages.find((l: Language) => l.value === props.selected)
                ?.flagCode || ''
            }
          />
        </span>
        <img
          src={ArrowDown}
          alt="Arrow down"
          className="w-3 h-2 mt-1"
          {...getIdAttributes(idPrefix, 'language-arrow-icon')}
        />
      </button>

      {openLanguageModal && (
        <div
          className="language-toggle-open-modal"
          {...getIdAttributes(idPrefix, 'language-toggle-modal')}
        >
          <div className="select-language">Select your language</div>
          <ul>
            {languages.map((lang: Language) => (
              <li
                key={lang.value}
                onClick={() => handleSelect(lang.value)}
                className={`languages-modal ${
                  lang.value === props.selected
                    ? 'bg-INPUT_THEME_COLOR mb-2'
                    : ''
                }`}
                {...getIdAttributes(idPrefix, `option-${lang.value}`)}
              >
                <span className="flex items-center gap-2">
                  <span>
                    <FlagIcon svg={lang.flagCode} />
                  </span>
                  <span>{lang.label}</span>
                </span>
                {lang.value === props.selected && (
                  <img
                    src={ActiveCheck}
                    alt="Active Check"
                    className="w-4 h-4"
                    {...getIdAttributes(idPrefix, `active-check-${lang.value}`)}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
